module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    staticClass: "img-loading",
    attrs: {
      "src": "/static/images/white.gif",
      "width": "150",
      "alt": "Loading"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-loading"
  }, [_vm._v("Cargando")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78babe5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/partials/Loading.vue
// module id = 463
// module chunks = 1